(function () {
  'use strict';

  const STORAGE_CP_KEY = 'royalplant_climate_cp';
  const STORAGE_PROFILE_KEY = 'royalplant_climate_profile';
  const COOKIE_MAX_AGE = 60 * 60 * 24 * 180;
  const MODAL_SELECTOR = '[data-rp-zone-modal-v3]';
  const BADGE_SELECTOR = '[data-rp-climate-badge-v3]';
  const TRIGGER_VALUE_SELECTOR = '[data-rp-zone-trigger-value]';
  let eventsBound = false;
  let triggerObserver = null;
  let triggerUpdateQueued = false;

  const RP_CLIMATE_ZONES = {
    '01': { province: 'Álava', usda: 8, heat: 5, climate: 'B', label: 'Continental fresco' },
    '02': { province: 'Albacete', usda: 8, heat: 8, climate: 'C', label: 'Continental seco' },
    '03': { province: 'Alicante', usda: 10, heat: 8, climate: 'D', label: 'Mediterráneo costa' },
    '04': { province: 'Almería', usda: 10, heat: 9, climate: 'E', label: 'Mediterráneo cálido seco' },
    '05': { province: 'Ávila', usda: 7, heat: 6, climate: 'B', label: 'Continental frío' },
    '06': { province: 'Badajoz', usda: 9, heat: 9, climate: 'E', label: 'Mediterráneo cálido seco' },
    '07': { province: 'Baleares', usda: 10, heat: 7, climate: 'D', label: 'Mediterráneo insular' },
    '08': { province: 'Barcelona', usda: 9, heat: 7, climate: 'D', label: 'Mediterráneo costa/interior' },
    '09': { province: 'Burgos', usda: 7, heat: 5, climate: 'B', label: 'Continental frío' },
    '10': { province: 'Cáceres', usda: 9, heat: 8, climate: 'C', label: 'Continental templado seco' },
    '11': { province: 'Cádiz', usda: 10, heat: 8, climate: 'D', label: 'Mediterráneo atlántico suave' },
    '12': { province: 'Castellón', usda: 10, heat: 7, climate: 'D', label: 'Mediterráneo costa' },
    '13': { province: 'Ciudad Real', usda: 8, heat: 8, climate: 'C', label: 'Continental seco' },
    '14': { province: 'Córdoba', usda: 9, heat: 9, climate: 'E', label: 'Mediterráneo cálido seco' },
    '15': { province: 'A Coruña', usda: 9, heat: 4, climate: 'A', label: 'Atlántico húmedo' },
    '16': { province: 'Cuenca', usda: 8, heat: 6, climate: 'B', label: 'Continental fresco' },
    '17': { province: 'Girona', usda: 9, heat: 6, climate: 'D', label: 'Mediterráneo norte' },
    '18': { province: 'Granada', usda: 8, heat: 8, climate: 'C', label: 'Continental-mediterráneo' },
    '19': { province: 'Guadalajara', usda: 8, heat: 6, climate: 'B', label: 'Continental fresco' },
    '20': { province: 'Gipuzkoa', usda: 9, heat: 4, climate: 'A', label: 'Atlántico húmedo' },
    '21': { province: 'Huelva', usda: 10, heat: 8, climate: 'E', label: 'Mediterráneo cálido atlántico' },
    '22': { province: 'Huesca', usda: 7, heat: 6, climate: 'B', label: 'Continental frío' },
    '23': { province: 'Jaén', usda: 9, heat: 9, climate: 'E', label: 'Mediterráneo cálido seco' },
    '24': { province: 'León', usda: 7, heat: 5, climate: 'B', label: 'Continental frío' },
    '25': { province: 'Lleida', usda: 8, heat: 8, climate: 'C', label: 'Continental seco' },
    '26': { province: 'La Rioja', usda: 8, heat: 6, climate: 'B', label: 'Continental fresco' },
    '27': { province: 'Lugo', usda: 8, heat: 4, climate: 'A', label: 'Atlántico interior' },
    '28': { province: 'Madrid', usda: 9, heat: 8, climate: 'C', label: 'Continental seco urbano' },
    '29': { province: 'Málaga', usda: 10, heat: 8, climate: 'D', label: 'Mediterráneo costa cálida' },
    '30': { province: 'Murcia', usda: 10, heat: 9, climate: 'E', label: 'Mediterráneo cálido seco' },
    '31': { province: 'Navarra', usda: 8, heat: 6, climate: 'B', label: 'Continental norte' },
    '32': { province: 'Ourense', usda: 8, heat: 6, climate: 'A', label: 'Atlántico interior cálido' },
    '33': { province: 'Asturias', usda: 9, heat: 4, climate: 'A', label: 'Atlántico húmedo' },
    '34': { province: 'Palencia', usda: 8, heat: 5, climate: 'B', label: 'Continental frío' },
    '35': { province: 'Las Palmas', usda: 11, heat: 6, climate: 'F', label: 'Subtropical' },
    '36': { province: 'Pontevedra', usda: 9, heat: 4, climate: 'A', label: 'Atlántico húmedo' },
    '37': { province: 'Salamanca', usda: 8, heat: 6, climate: 'B', label: 'Continental frío' },
    '38': { province: 'Santa Cruz de Tenerife', usda: 11, heat: 6, climate: 'F', label: 'Subtropical' },
    '39': { province: 'Cantabria', usda: 9, heat: 4, climate: 'A', label: 'Atlántico húmedo' },
    '40': { province: 'Segovia', usda: 7, heat: 5, climate: 'B', label: 'Continental frío' },
    '41': { province: 'Sevilla', usda: 10, heat: 10, climate: 'E', label: 'Mediterráneo muy cálido seco' },
    '42': { province: 'Soria', usda: 8, heat: 5, climate: 'B', label: 'Continental frío' },
    '43': { province: 'Tarragona', usda: 9, heat: 7, climate: 'D', label: 'Mediterráneo costa' },
    '44': { province: 'Teruel', usda: 7, heat: 6, climate: 'B', label: 'Continental frío' },
    '45': { province: 'Toledo', usda: 8, heat: 8, climate: 'C', label: 'Continental seco' },
    '46': { province: 'Valencia', usda: 10, heat: 8, climate: 'D', label: 'Mediterráneo costa' },
    '47': { province: 'Valladolid', usda: 8, heat: 6, climate: 'B', label: 'Continental frío' },
    '48': { province: 'Bizkaia', usda: 9, heat: 4, climate: 'A', label: 'Atlántico húmedo' },
    '49': { province: 'Zamora', usda: 8, heat: 6, climate: 'B', label: 'Continental frío' },
    '50': { province: 'Zaragoza', usda: 8, heat: 8, climate: 'C', label: 'Continental seco' },
    '51': { province: 'Ceuta', usda: 11, heat: 7, climate: 'F', label: 'Subtropical mediterráneo' },
    '52': { province: 'Melilla', usda: 11, heat: 8, climate: 'F', label: 'Subtropical mediterráneo' },
  };

  const STATUS_COPY = {
    optima: { label: 'Resultado', title: 'Óptima para tu zona', messageKey: 'badgeOptima' },
    recomendada: { label: 'Resultado', title: 'Recomendada para tu jardín', messageKey: 'badgeRecomendada' },
    posible: { label: 'Resultado', title: 'Posible con cuidados', messageKey: 'badgePosible' },
    delicada: { label: 'Resultado', title: 'Requiere ubicación cuidada', messageKey: 'badgeDelicada' },
  };

  function normalizePostalCode(cp) {
    return String(cp || '').replace(/\D/g, '').slice(0, 5);
  }

  function getProfileFromPostalCode(cp) {
    const normalizedCp = normalizePostalCode(cp);
    if (normalizedCp.length !== 5) return null;

    const zone = RP_CLIMATE_ZONES[normalizedCp.slice(0, 2)];
    if (!zone) return null;

    return Object.assign({ cp: normalizedCp }, zone);
  }

  function safeLocalStorageGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeLocalStorageSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {}
  }

  function safeLocalStorageRemove(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {}
  }

  function setCookie(key, value) {
    document.cookie = `${key}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
  }

  function getCookie(key) {
    const prefix = `${key}=`;
    return document.cookie
      .split(';')
      .map((item) => item.trim())
      .find((item) => item.indexOf(prefix) === 0)
      ?.slice(prefix.length);
  }

  function safeDecode(value) {
    try {
      return decodeURIComponent(value || '');
    } catch (error) {
      return value || '';
    }
  }

  function deleteCookie(key) {
    document.cookie = `${key}=; path=/; max-age=0; SameSite=Lax`;
  }

  function readProfileJson(value) {
    if (!value) return null;

    try {
      const profile = JSON.parse(safeDecode(value));
      return profile && profile.cp ? profile : null;
    } catch (error) {
      return null;
    }
  }

  function persistProfileEverywhere(profile) {
    const serializedProfile = JSON.stringify(profile);
    safeLocalStorageSet(STORAGE_CP_KEY, profile.cp);
    safeLocalStorageSet(STORAGE_PROFILE_KEY, serializedProfile);
    setCookie(STORAGE_CP_KEY, profile.cp);
    setCookie(STORAGE_PROFILE_KEY, serializedProfile);
  }

  function saveUserClimateProfile(profile) {
    if (!profile || !profile.cp) return;
    persistProfileEverywhere(profile);
    window.dispatchEvent(new CustomEvent('royalplant:climate-profile-updated', { detail: profile }));
  }

  function clearUserClimateProfile() {
    safeLocalStorageRemove(STORAGE_CP_KEY);
    safeLocalStorageRemove(STORAGE_PROFILE_KEY);
    deleteCookie(STORAGE_CP_KEY);
    deleteCookie(STORAGE_PROFILE_KEY);
    window.dispatchEvent(new CustomEvent('royalplant:climate-profile-updated', { detail: null }));
  }

  function getUserClimateProfile() {
    const localProfile = readProfileJson(safeLocalStorageGet(STORAGE_PROFILE_KEY));
    if (localProfile) return localProfile;

    const cookieProfile = readProfileJson(getCookie(STORAGE_PROFILE_KEY));
    if (cookieProfile) {
      persistProfileEverywhere(cookieProfile);
      return cookieProfile;
    }

    const localCp = safeLocalStorageGet(STORAGE_CP_KEY);
    const profileFromLocalCp = localCp ? getProfileFromPostalCode(localCp) : null;
    if (profileFromLocalCp) {
      persistProfileEverywhere(profileFromLocalCp);
      return profileFromLocalCp;
    }

    const cookieCp = safeDecode(getCookie(STORAGE_CP_KEY));
    const profileFromCookieCp = cookieCp ? getProfileFromPostalCode(cookieCp) : null;
    if (profileFromCookieCp) persistProfileEverywhere(profileFromCookieCp);
    return profileFromCookieCp;
  }

  function getProfileFromCoordinates(latitude, longitude) {
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

    if (latitude >= 27 && latitude <= 30 && longitude >= -18.5 && longitude <= -13) {
      return { cp: 'Ubicación actual', province: 'Canarias', usda: 11, heat: 6, climate: 'F', label: 'Subtropical', source: 'geolocation' };
    }

    if (latitude >= 38.4 && latitude <= 40.3 && longitude >= 1 && longitude <= 4.6) {
      return { cp: 'Ubicación actual', province: 'Baleares', usda: 10, heat: 7, climate: 'D', label: 'Mediterráneo insular', source: 'geolocation' };
    }

    if (latitude > 42 && longitude < -1.2) {
      return { cp: 'Ubicación actual', province: 'Norte atlántico', usda: 9, heat: 4, climate: 'A', label: 'Atlántico húmedo', source: 'geolocation' };
    }

    if (longitude > -1 && latitude < 41.8) {
      const isVeryWarm = latitude < 38.8 || (latitude < 40 && longitude < -0.2);
      return {
        cp: 'Ubicación actual',
        province: 'Litoral mediterráneo',
        usda: isVeryWarm ? 10 : 9,
        heat: isVeryWarm ? 9 : 7,
        climate: isVeryWarm ? 'E' : 'D',
        label: isVeryWarm ? 'Mediterráneo cálido seco' : 'Mediterráneo costa',
        source: 'geolocation',
      };
    }

    if (latitude < 38.7 && longitude < -1) {
      return { cp: 'Ubicación actual', province: 'Sur interior', usda: 9, heat: 9, climate: 'E', label: 'Mediterráneo cálido seco', source: 'geolocation' };
    }

    if (latitude > 41.2) {
      return { cp: 'Ubicación actual', province: 'Interior norte', usda: 8, heat: 6, climate: 'B', label: 'Continental fresco', source: 'geolocation' };
    }

    return { cp: 'Ubicación actual', province: 'Interior peninsular', usda: 9, heat: 8, climate: 'C', label: 'Continental seco', source: 'geolocation' };
  }

  function toNumber(value) {
    if (value === null || value === undefined || value === '') return null;
    const number = Number(String(value).replace(',', '.'));
    return Number.isFinite(number) ? number : null;
  }

  function parseList(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value.map(String).map((item) => item.trim()).filter(Boolean);

    return String(value)
      .replace(/^\[|\]$/g, '')
      .replace(/"/g, '')
      .split(/[,\|;]/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function includesClimate(list, climate) {
    return parseList(list).some((item) => item.toUpperCase() === String(climate || '').toUpperCase());
  }

  function isBetween(value, min, max) {
    const hasMin = min !== null && min !== undefined;
    const hasMax = max !== null && max !== undefined;
    if (!hasMin && !hasMax) return true;
    if (hasMin && value < min) return false;
    if (hasMax && value > max) return false;
    return true;
  }

  function overBy(value, max) {
    if (max === null || max === undefined) return 0;
    return Math.max(0, value - max);
  }

  function underBy(value, min) {
    if (min === null || min === undefined) return 0;
    return Math.max(0, min - value);
  }

  function evaluatePlantForUser(user, plant) {
    if (!user || !plant) return { status: null };

    const climateOptima = includesClimate(plant.climasOptimos, user.climate);
    const climateApta = includesClimate(plant.climasAptos, user.climate) || climateOptima;
    const climateCuidados = includesClimate(plant.climasConCuidados, user.climate);
    const climateDelicada = includesClimate(plant.climasDelicados, user.climate);
    const usdaOptima = isBetween(user.usda, plant.usdaOptimaMin, plant.usdaOptimaMax);
    const heatOptima = isBetween(user.heat, plant.heatOptimaMin, plant.heatOptimaMax);
    const usdaRecommended = isBetween(user.usda, plant.usdaMin, plant.usdaMaxRecommended);
    const heatRecommended = isBetween(user.heat, plant.heatMin, plant.heatMaxRecommended);
    const usdaCare = isBetween(user.usda, plant.usdaMin, plant.usdaMaxCare);
    const heatCare = isBetween(user.heat, plant.heatMin, plant.heatMaxCare);

    if (climateOptima && usdaOptima && heatOptima) {
      return { status: 'optima' };
    }

    if (climateApta && usdaRecommended && heatRecommended) {
      return { status: 'recomendada' };
    }

    const factorFailures = [
      climateDelicada,
      !usdaCare,
      !heatCare,
    ].filter(Boolean).length;

    const nearMisses = [
      overBy(user.usda, plant.usdaMaxCare),
      underBy(user.usda, plant.usdaMin),
      overBy(user.heat, plant.heatMaxCare),
      underBy(user.heat, plant.heatMin),
    ].filter((distance) => distance > 0 && distance <= 1).length;

    if (factorFailures >= 2) {
      return { status: 'delicada' };
    }

    if (factorFailures === 1 && nearMisses === 0) {
      return { status: 'delicada' };
    }

    if (climateCuidados || factorFailures === 1 || usdaCare || heatCare) {
      return { status: 'posible' };
    }

    return { status: 'delicada' };
  }

  function plantProfileFromBadge(badge) {
    const data = badge.dataset;

    return {
      taxon: data.taxon || '',
      usdaMin: toNumber(data.usdaMin),
      usdaMaxRecommended: toNumber(data.usdaMaxRecommended),
      usdaMaxCare: toNumber(data.usdaMaxCare),
      usdaOptimaMin: toNumber(data.usdaOptimaMin),
      usdaOptimaMax: toNumber(data.usdaOptimaMax),
      heatMin: toNumber(data.heatMin),
      heatMaxRecommended: toNumber(data.heatMaxRecommended),
      heatMaxCare: toNumber(data.heatMaxCare),
      heatOptimaMin: toNumber(data.heatOptimaMin),
      heatOptimaMax: toNumber(data.heatOptimaMax),
      climasOptimos: data.climasOptimos || '',
      climasAptos: data.climasAptos || '',
      climasConCuidados: data.climasConCuidados || '',
      climasDelicados: data.climasDelicados || '',
      badgeOptima: data.badgeOptima || '',
      badgeRecomendada: data.badgeRecomendada || '',
      badgePosible: data.badgePosible || '',
      badgeDelicada: data.badgeDelicada || '',
    };
  }

  function renderEmptyBadge(badge) {
    badge.removeAttribute('data-rp-status');
    badge.innerHTML = `
      <div class="rp-climate-badge-v3__content">
        <span class="rp-climate-badge-v3__eyebrow">Recomendación personalizada</span>
        <h3 class="rp-climate-badge-v3__empty-title">Comprueba esta planta en tu zona</h3>
        <p class="rp-climate-badge-v3__text">Guarda tu código postal aquí o desde la barra superior. La recomendación se actualizará en toda la tienda.</p>
        <button type="button" class="rp-climate-badge-v3__button" data-rp-open-zone-modal>
          <span class="rp-climate-badge-v3__pin" aria-hidden="true"></span>
          <span class="rp-climate-badge-v3__button-main">
            Guardar zona climática
            <span class="rp-climate-badge-v3__button-strong">Código postal o ubicación actual</span>
          </span>
          <span class="rp-climate-badge-v3__chevron" aria-hidden="true"></span>
        </button>
      </div>
    `;
  }

  function renderResultBadge(badge, userProfile, plantProfile, result) {
    const copy = STATUS_COPY[result.status] || STATUS_COPY.posible;
    const message = plantProfile[copy.messageKey] || 'Consulta las condiciones de plantación recomendadas para esta especie.';
    const zoneCp = userProfile.source === 'geolocation' ? 'Ubicación actual' : `CP ${escapeHtml(userProfile.cp)}`;
    badge.setAttribute('data-rp-status', result.status);
    badge.innerHTML = `
      <div class="rp-climate-badge-v3__result">
        <div class="rp-climate-badge-v3__headline">
          <span class="rp-climate-badge-v3__label">Diagnóstico climático</span>
          <span class="rp-climate-badge-v3__title">${copy.title}</span>
        </div>
        <p class="rp-climate-badge-v3__message">${escapeHtml(message)}</p>
        <div class="rp-climate-badge-v3__zone">
          <span>Tu zona guardada</span>
          <strong>${escapeHtml(userProfile.province || 'Zona estimada')}</strong>
          <small>${escapeHtml(userProfile.label)} · ${zoneCp}</small>
        </div>
        <p class="rp-climate-badge-v3__note">Estimación orientativa basada en frío, calor estival y clima local. Puede variar por altitud, exposición, viento, suelo, riego y microclima.</p>
        <div class="rp-climate-badge-v3__actions">
          <button type="button" class="rp-climate-badge-v3__change" data-rp-open-zone-modal>Cambiar zona</button>
          <button type="button" class="rp-climate-badge-v3__clear" data-rp-clear-zone>Borrar zona</button>
        </div>
      </div>
    `;
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = String(value || '');
    return div.innerHTML;
  }

  function updateAllClimateBadges() {
    const userProfile = getUserClimateProfile();
    updateZoneTriggers(userProfile);

    document.querySelectorAll(BADGE_SELECTOR).forEach((badge) => {
      if (!userProfile) {
        renderEmptyBadge(badge);
        return;
      }

      const plantProfile = plantProfileFromBadge(badge);
      const result = evaluatePlantForUser(userProfile, plantProfile);
      renderResultBadge(badge, userProfile, plantProfile, result);
    });
  }

  function updateZoneTriggers(userProfile) {
    document.querySelectorAll(TRIGGER_VALUE_SELECTOR).forEach((value) => {
      value.textContent = userProfile
        ? (userProfile.source === 'geolocation' ? 'Ubicación actual' : `${userProfile.cp} · ${userProfile.province}`)
        : 'Introduce tu CP';
    });
  }

  function scheduleZoneTriggerUpdate() {
    if (triggerUpdateQueued) return;
    triggerUpdateQueued = true;
    requestAnimationFrame(() => {
      triggerUpdateQueued = false;
      updateZoneTriggers(getUserClimateProfile());
    });
  }

  function observeTriggerChanges() {
    if (triggerObserver || !document.body) return;

    triggerObserver = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length > 0)) {
        scheduleZoneTriggerUpdate();
      }
    });

    triggerObserver.observe(document.body, { childList: true, subtree: true });
  }

  function openModal() {
    const modal = document.querySelector(MODAL_SELECTOR);
    if (!modal) return;

    const profile = getUserClimateProfile();
    const input = modal.querySelector('[data-rp-zone-postal-code]');
    const preview = modal.querySelector('[data-rp-zone-preview]');
    const error = modal.querySelector('[data-rp-zone-error]');
    const success = modal.querySelector('[data-rp-zone-success]');
    const clear = modal.querySelector('[data-rp-clear-zone]');
    const dialog = modal.querySelector('.rp-zone-modal-v3__dialog');

    if (input) input.value = profile && profile.source !== 'geolocation' ? profile.cp : '';
    if (preview) preview.textContent = profile ? `Zona climática: ${profile.label}` : 'Zona climática: pendiente';
    if (error) error.hidden = true;
    if (success) success.hidden = true;
    if (clear) clear.hidden = !profile;

    modal.hidden = false;
    document.documentElement.classList.add('rp-zone-modal-v3-open');
    window.requestAnimationFrame(() => {
      if (dialog) dialog.scrollTop = 0;
      modal.scrollTop = 0;

      if (window.matchMedia('(min-width: 750px)').matches) {
        input?.focus();
      }
    });
  }

  function closeModal() {
    const modal = document.querySelector(MODAL_SELECTOR);
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('rp-zone-modal-v3-open');
  }

  function handleSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const input = form.querySelector('[data-rp-zone-postal-code]');
    const preview = form.querySelector('[data-rp-zone-preview]');
    const error = form.querySelector('[data-rp-zone-error]');
    const success = form.querySelector('[data-rp-zone-success]');
    const clear = form.querySelector('[data-rp-clear-zone]');
    const normalizedCp = normalizePostalCode(input?.value);

    if (!normalizedCp) {
      clearUserClimateProfile();
      if (input) input.value = '';
      if (preview) preview.textContent = 'Zona climática: pendiente';
      if (error) error.hidden = true;
      if (success) {
        success.textContent = 'Zona borrada.';
        success.hidden = false;
      }
      if (clear) clear.hidden = true;
      updateAllClimateBadges();
      return;
    }

    const profile = getProfileFromPostalCode(normalizedCp);

    if (!profile) {
      if (success) success.hidden = true;
      if (error) {
        error.textContent = 'Introduce un código postal español válido de 5 dígitos.';
        error.hidden = false;
      }
      return;
    }

    saveUserClimateProfile(profile);
    if (preview) preview.textContent = `Zona climática: ${profile.label}`;
    if (error) error.hidden = true;
    if (success) {
      success.textContent = `Zona guardada: ${profile.province}, ${profile.label}.`;
      success.hidden = false;
    }
    if (clear) clear.hidden = false;
    updateAllClimateBadges();
    window.setTimeout(closeModal, 650);
  }

  function handleClearZone(event) {
    const button = event.target.closest('[data-rp-clear-zone]');
    if (!button) return;

    const modal = document.querySelector(MODAL_SELECTOR);
    const input = modal?.querySelector('[data-rp-zone-postal-code]');
    const preview = modal?.querySelector('[data-rp-zone-preview]');
    const error = modal?.querySelector('[data-rp-zone-error]');
    const success = modal?.querySelector('[data-rp-zone-success]');
    const clear = modal?.querySelector('[data-rp-clear-zone]');

    clearUserClimateProfile();
    if (input) input.value = '';
    if (preview) preview.textContent = 'Zona climática: pendiente';
    if (error) error.hidden = true;
    if (success) {
      success.textContent = 'Zona borrada.';
      success.hidden = false;
    }
    if (clear) clear.hidden = true;
    updateAllClimateBadges();
  }

  function handleUseCurrentLocation(event) {
    const button = event.target.closest('[data-rp-use-current-location]');
    if (!button) return;

    const modal = document.querySelector(MODAL_SELECTOR);
    const preview = modal?.querySelector('[data-rp-zone-preview]');
    const error = modal?.querySelector('[data-rp-zone-error]');
    const success = modal?.querySelector('[data-rp-zone-success]');
    const clear = modal?.querySelector('[data-rp-clear-zone]');

    if (!navigator.geolocation) {
      if (error) {
        error.textContent = 'Tu navegador no permite usar la ubicación actual.';
        error.hidden = false;
      }
      return;
    }

    button.disabled = true;
    button.textContent = 'Detectando...';
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const profile = getProfileFromCoordinates(position.coords.latitude, position.coords.longitude);
        button.disabled = false;
        button.textContent = 'Ubicación actual';

        if (!profile) {
          if (error) {
            error.textContent = 'No hemos podido estimar tu zona climática con la ubicación actual.';
            error.hidden = false;
          }
          return;
        }

        saveUserClimateProfile(profile);
        if (preview) preview.textContent = `Zona climática: ${profile.label}`;
        if (error) error.hidden = true;
        if (success) {
          success.textContent = `Zona guardada: ${profile.label}.`;
          success.hidden = false;
        }
        if (clear) clear.hidden = false;
        updateAllClimateBadges();
        window.setTimeout(closeModal, 650);
      },
      () => {
        button.disabled = false;
        button.textContent = 'Ubicación actual';
        if (error) {
          error.textContent = 'No se ha podido acceder a tu ubicación. Puedes introducir tu código postal manualmente.';
          error.hidden = false;
        }
      },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 3600000 }
    );
  }

  function handlePostalPreview(event) {
    const input = event.target;
    if (!input.matches('[data-rp-zone-postal-code]')) return;

    const form = input.closest('[data-rp-zone-form]');
    const preview = form?.querySelector('[data-rp-zone-preview]');
    if (!preview) return;

    const normalizedCp = normalizePostalCode(input.value);
    const profile = getProfileFromPostalCode(normalizedCp);
    if (profile) {
      preview.textContent = `Zona climática: ${profile.label}`;
      return;
    }

    preview.textContent = normalizedCp.length >= 2 ? 'Zona climática: sin datos para ese prefijo' : 'Zona climática: pendiente';
  }

  function bindEvents() {
    if (eventsBound) return;
    eventsBound = true;

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-rp-open-zone-modal]')) openModal();
      if (event.target.closest('[data-rp-close-zone-modal]')) closeModal();
      handleClearZone(event);
      handleUseCurrentLocation(event);
    });

    document.addEventListener('submit', (event) => {
      if (event.target.matches('[data-rp-zone-form]')) handleSubmit(event);
    });

    document.addEventListener('input', handlePostalPreview);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal();
    });

    window.addEventListener('storage', (event) => {
      if (event.key === STORAGE_CP_KEY || event.key === STORAGE_PROFILE_KEY) updateAllClimateBadges();
    });

    window.addEventListener('royalplant:climate-profile-updated', updateAllClimateBadges);
    window.addEventListener('pageshow', updateAllClimateBadges);
    document.addEventListener('shopify:section:load', updateAllClimateBadges);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) updateAllClimateBadges();
    });
  }

  function init() {
    bindEvents();
    observeTriggerChanges();
    updateAllClimateBadges();
    requestAnimationFrame(updateAllClimateBadges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.RoyalPlantClimateV3 = {
    zones: RP_CLIMATE_ZONES,
    getProfileFromPostalCode,
    saveUserClimateProfile,
    clearUserClimateProfile,
    getUserClimateProfile,
    getProfileFromCoordinates,
    evaluatePlantForUser,
    updateAllClimateBadges,
    openModal,
    closeModal,
  };
})();
